import books from './books/booksReducer'

export default {
    books,
}